import { render, staticRenderFns } from "./UserEvents.vue?vue&type=template&id=fab5c7d8"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"
import style0 from "./UserEvents.vue?vue&type=style&index=0&id=fab5c7d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports